export default "__VITE_ASSET__a65ae54d__"